<template>
    <div>
        <!-- <van-nav-bar title="转账汇款" /> -->
        <van-Row>
            <van-Col span="24">
                <img width="100%" :src=zzpzImg />
                <div style="margin:16px;">
                    <div class="zzhkCon">
                        <dl class="yhkmm">
                            <dt>收款账户</dt>
                            <dd>汇款账号：{{transfer.accountNumber}}</dd>
                            <dd>户   名：{{transfer.accountName}}</dd>
                            <dd>开 户 行：{{transfer.bankName}}</dd>
                        </dl>

                        <dl class="zysx">
                            <dt>注意事项</dt>
                            <!-- <dd>汇款时请备注：姓名+报名手机号+2024CHITEC</dd> -->
                            <dd>{{transfer.payNotice}}</dd>
                        </dl>
                    </div>
                </div>
                <div style="margin:50px 16px 16px;"><van-button round block type="info" class="bottom-button" @click="grzxLink">查看报名信息</van-button></div>
            </van-Col>
        </van-Row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: 0,
            zzpzImg:require('../../assets/images/zzpzbzimg.jpg'),
			transfer: JSON.parse(sessionStorage.getItem('transfer'))
            
        };
    },
    created(){
      // this.getEnteredListByCurrent();
    },
    methods:{
      grzxLink(){
        // console.log(Global.loginUrl)
        const token = sessionStorage.getItem('sessionGrzxToken_'+this.$cookies.get('meetingId'));
        if(!token){
          this.$router.push('/personal/login?meetingId='+this.$cookies.get('meetingId'));
        }else{
          this.$router.push('/personal/index')
        }
      },
        getEnteredListByCurrent(){
    //       var transfer = sessionStorage.getItem('transfer');
		  // this.bankName = transfer.bankName,
		  // this.accountName = transfer.accountName,
		  // this.accountNumber = transfer.accountNumber;
		  // this.payNotice = transfer.payNotice;
          
        },
        sczzpz(){
            this.$router.push('/charge/remittance/index');
        }
    }
};
</script>

<style scoped>
    .van-steps span{
        font-size: 14px;
    }
    .van-icon{
      font-size: 20px;
    }
    .zysx dt{
        color:#333;
        line-height: 50px;
        font-size: 18px;
    }
    .zysx dd{
        font-size: 16px;
        color:#666;
        line-height: 26px;
        text-align: justify;
    }
    .zysx dd{
        padding-bottom: 10px;
        margin:0;
        display: flex;
    }
    .zysx dd span{
      font-size: 20px;
      margin-right: 5px;
      color:#edc087;
    }
    .yhkmm{
      background: url(~@/assets/images/yhkbg.png) no-repeat;
      background-size: 100% 100%;
      color:#fff;
      padding:20px;
    }
    .yhkmm dt{
      padding:10px 0 30px;
      font-size: 20px;
    }
    .yhkmm dd{
      margin:0;
      line-height: 26px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Charge/remittance.vue